import { TableConfiguration } from 'src/common/components/Sim/Inventory/constants/columnConfigurationsConstants';
import {
  saveSimProductsColumnWidth,
  saveSimProductTableConfiguration,
} from '../../../api/simProductsTableConfigurationApi';
import { simProductsQueries } from '../../../queries/simProductsQueries';
import { useColumnActions } from 'src/common/components/Sim/Inventory/hooks/useColumnActions';

export const useSimProductsColumnActions = (configuration: TableConfiguration) => {
  return useColumnActions({
    configuration,
    saveColumnWidth: saveSimProductsColumnWidth,
    saveConfiguration: saveSimProductTableConfiguration,
    queryKey: simProductsQueries.lists(),
  });
};
